import { createContext, useContext } from "react";

export interface CheckStockParams {
  searchCode: string;
  searchType: "UPC" | "SKU";
  fallbackCode?: string;
  fallbackType?: "SKU";
}

/**
 * The page-level nearby stock search (the same one the list row's Check stock
 * uses), so a product detail sheet can close itself and open the results modal
 * instead of navigating away. Null outside a page that provides it.
 */
export const CheckStockContext = createContext<((params: CheckStockParams) => void | Promise<void>) | null>(null);

export const usePageCheckStock = () => useContext(CheckStockContext);
